import {forwardRef} from "react";

import {Box} from "@styled-system/jsx";

import {ButtonV2} from "@/components/primitives/buttonV2";

import {css} from "@styled-system/css";

interface IProps {
    isDisabled: boolean;
    isLoading?: boolean;
    onClick: () => void;
    children: React.ReactNode;
}

export const PrimaryCTAButton = forwardRef<HTMLButtonElement, IProps>((props, ref) => {
    return (
        <Box
            className={css({
                display: "flex",
                width: "100%",
                justifyContent: "center",
                gap: "2",
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                padding: "4",
                pb: "0"
            })}>
            <ButtonV2
                shape="default"
                variant="action"
                disabled={props.isDisabled || props.isLoading}
                isLoading={props.isLoading}
                size="lg"
                onClick={props.onClick}
                ref={ref}
                className={css({
                    height: "62px",
                    maxWidth: "containerSize",
                    width: "100%",
                    fontStyle: "italic",
                    fontWeight: "semibold",
                    fontFamily: "barlowCondensed",
                    fontSize: "1.4rem",
                    letterSpacing: "wide",
                    rounded: "0"
                })}>
                {props.children}
            </ButtonV2>
        </Box>
    );
});

PrimaryCTAButton.displayName = "PrimaryCTAButton";
